import {Box, Button, Checkbox, FormControlLabel, Link, TextField, Typography} from '@mui/material';
import {useRef} from 'react';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

export default function EnterPlayerEmailStep({nextStep, handleChange, workFlowData}) {
  const emailFieldRef = useRef();
  const wantsNewslettersEmailsRef = useRef();
  const {t} = useTranslation();

  const onSubmit = (e) => {
    e.preventDefault();

    handleChange({
      email: emailFieldRef.current.value,
      wantsNewslettersEmails: wantsNewslettersEmailsRef.current.checked,
    });
    nextStep();
  };

  function onSkipEmail() {
    handleChange({email: '', wantsNewslettersEmails: false});
    nextStep();
  }

  return (
    <div>
      <Typography variant="h2" gutterBottom marked="center" align="center">
        {t('email-title')}
      </Typography>

      <Box component="form" onSubmit={onSubmit} sx={{mt: 6}}>
        <TextField
          inputRef={emailFieldRef}
          label={t('email')}
          autoFocus
          fullWidth
          margin="normal"
          name="Email"
          type="email"
          required
          size="large"
          defaultValue={workFlowData.email}
        />
        <FormControlLabel
          control={
            <Checkbox
              inputRef={wantsNewslettersEmailsRef}
              defaultChecked={workFlowData.wantsNewslettersEmails}
              name="wantsNewslettersEmails"
            />
          }
          label={t('newsletter')}
        />

        <Button
          type={'submit'}
          fullWidth
        >
          {t('next-button')}
        </Button>
        <Grid container justifyContent={'flex-end'}>
          <Link href="#" onClick={onSkipEmail}>{t('skip-this-step')}</Link>
        </Grid>
      </Box>
    </div>
  );
}
EnterPlayerEmailStep.propTypes = {
  nextStep: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  workFlowData: PropTypes.any.isRequired,
};
